// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__1RgSg"};